import { useTranslation } from "react-i18next";
import { NotificationItemTransaction } from "@/stores/notifications/notificationStore";
import { notificationsTransactionList } from "@/domains/notifications/helpers/notificationsTransactionList";
import NotificationTransactionBody from "@/domains/notifications/components/NotificationsTransactionBody";

type Props = {
  item: NotificationItemTransaction;
};

export default function NotificationTransactionContainer({ item }: Props) {
  const { image, isIncrement } = notificationsTransactionList[item.data.type];
  const { t } = useTranslation("notifications");

  return (
    <NotificationTransactionBody
      image={image}
      isIncrement={isIncrement}
      text={t(`payment.${item.data.type}.text`)}
      title={t(`payment.${item.data.type}.title`)}
      value={item.data.amount}
    />
  );
}
